<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosBlackList"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="customerName" :label="t('operate.r1nt24')">
              <a-input v-model:value="queryForm.customerName" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item name="arkCode" :label="t('operate.o85u5a')">
              <a-input v-model:value="queryForm.arkCode" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'enableFlag'"> {{ t('operate.udrs3c') }} </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="'ofbu_blacklist_edit_btn'">{{
                t('btn.edit')
              }}</a-button>

              <a-button type="link" @click="deleteRow(record)" v-permission="'ofbu_blacklist_delete_btn'">{{
                t('btn.del')
              }}</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()" v-permission="'ofbu_blacklist_add_btn'">{{
            t('btn.add')
          }}</a-button>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { blackFindByPage, deleteData } from '@/api/overseasSales/blackList'
import { listByParamCodes } from '@/api/common'
import { useI18n } from 'vue-i18n'
import { DcMessage } from '@dc-platform/dc-components'
import { BlackFindByPageParams, BlackFindByPageBackData } from '@/typings/api/overseasSales'
export default { name: 'DcCosOFbuBlacklist' }
</script>
<script setup lang="ts">
const { t } = useI18n()
// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: BlackFindByPageBackData) => void }>()

const tableRef = ref()
const queryForm = reactive({
  customerName: '',
  arkCode: ''
})
const paramCodeData = ref([])
const getBlackReason = async () => {
  // 对列表数据进行修改。通过拉黑原因id查原因
  try {
    const res = await listByParamCodes({
      appId: 'cos_ofbu',
      paramCodes: ['ofbu_black_reason']
    })
    paramCodeData.value = res.data.ofbu_black_reason
  } catch (error) {
    console.log('getBlackReason error: ', error)
  }
}
// 获取列表
const fetch = async (params: BlackFindByPageParams, callBack: (res: any) => void) => {
  try {
    const res = await blackFindByPage({ ...params })
    await getBlackReason()
    callBack(res)
  } catch (error) {
    console.log('fetcherror: ', error)
  }
}

const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const columns = computed(() => [
  { title: t('operate.r1nt24'), dataIndex: 'customerName' },
  { title: t('operate.kmrvx1'), dataIndex: 'blacklistReason', dicData: paramCodeData.value },

  { title: t('operate.d855tr'), dataIndex: 'blacklistRemark' },
  { title: t('operate.lbczwf'), dataIndex: 'enableFlag' },
  {
    title: t('common.action'),
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BlackFindByPageBackData) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: BlackFindByPageBackData) => {
  Modal.delete({
    name: row.customerName,
    onOk() {
      deleteData(row.id).then(() => {
        DcMessage.success(t('operate.6k2ifb'))
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}
</script>

<style scoped></style>
